var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmartRoutesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.03992 5.07983V14.9575",
    stroke: "#5ACAD5",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.15918 1V10.8776",
    stroke: "#5ACAD5",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2783 9.9263V14.9575",
    stroke: "#5ACAD5",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2783 1V5.85549",
    stroke: "#5ACAD5",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.03991 5.07982C4.16652 5.07982 5.07982 4.16652 5.07982 3.03991C5.07982 1.9133 4.16652 1 3.03991 1C1.9133 1 1 1.9133 1 3.03991C1 4.16652 1.9133 5.07982 3.03991 5.07982Z",
    stroke: "#5ACAD5",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.15917 14.9575C9.28578 14.9575 10.1991 14.0442 10.1991 12.9176C10.1991 11.791 9.28578 10.8777 8.15917 10.8777C7.03256 10.8777 6.11926 11.791 6.11926 12.9176C6.11926 14.0442 7.03256 14.9575 8.15917 14.9575Z",
    stroke: "#5ACAD5",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2784 9.93532C14.405 9.93532 15.3183 9.02202 15.3183 7.89541C15.3183 6.7688 14.405 5.8555 13.2784 5.8555C12.1518 5.8555 11.2385 6.7688 11.2385 7.89541C11.2385 9.02202 12.1518 9.93532 13.2784 9.93532Z",
    stroke: "#5ACAD5",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartRoutesIcon);
export default __webpack_public_path__ + "static/media/smart-routes-icon.583ead5e1098416ecbf038e40c4fc435.svg";
export { ForwardRef as ReactComponent };